import React,{useState}from'react';import{ComponentRenderer}from"./unified";// The generated component code from ToDebug.tsx
import{jsx as _jsx,jsxs as _jsxs}from"react/jsx-runtime";const GENERATED_CODE=`"use client";

import React, { useState, useEffect, useCallback, useRef } from "react";
import { motion } from "framer-motion";
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import {
  ArrowUp,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  RotateCcw,
  CheckCircle,
  XCircle,
  Info,
} from "lucide-react";
// Assuming \`@/lib/utils\` contains a \`cn\` helper for conditional class names
import { cn } from "@/lib/utils";

// --- Constants ---
const VIEWPORT_WIDTH = 800;
const VIEWPORT_HEIGHT = 600;
const PLAYER_RADIUS = 15;
const SPRING_TRANSITION = {
  type: "spring",
  stiffness: 100,
  damping: 15,
};

// --- Types ---
type GravityDirection = "up" | "down" | "left" | "right";
type GameStatus = "initial" | "playing" | "win" | "lose";
interface Platform {
  x: number;
  y: number;
  width: number;
  height: number;
}
interface Target {
  x: number;
  y: number;
  radius: number;
}
interface LevelData {
  id: number;
  platforms: Platform[];
  playerStart: {
    x: number;
    y: number;
  };
  target: Target;
}
const LEVELS: LevelData[] = [
  {
    id: 1,
    platforms: [
      {
        x: 0,
        y: 550,
        width: VIEWPORT_WIDTH,
        height: 50,
      },
      // Ground
      {
        x: 100,
        y: 400,
        width: 200,
        height: 20,
      },
      {
        x: 500,
        y: 300,
        width: 150,
        height: 20,
      },
    ],
    playerStart: {
      x: 50,
      y: 500,
    },
    target: {
      x: 580,
      y: 250,
      radius: 20,
    },
  },
];

const GravityGame: React.FC = () => {
  return (
    <Card className="w-full max-w-2xl mx-auto">
      <CardHeader>
        <h2>Gravity Game Test</h2>
      </CardHeader>
      <CardContent>
        <p>This is a test component to verify the dynamic loader works.</p>
      </CardContent>
    </Card>
  );
};

export default GravityGame;`;const DebugDynamicLoader=()=>{const[testCode,setTestCode]=useState(null);const[renderError,setRenderError]=useState(null);const startTest=()=>{console.log('=== STARTING COMPONENT RENDERER TEST ===');console.log('Generated code length:',GENERATED_CODE.length);console.log('First 200 chars:',GENERATED_CODE.substring(0,200));setTestCode(GENERATED_CODE);setRenderError(null);};const handleError=error=>{console.error('=== COMPONENT RENDERER ERROR ===',error);setRenderError(error);};return/*#__PURE__*/_jsxs("div",{className:"p-6 max-w-4xl mx-auto",children:[/*#__PURE__*/_jsx("h1",{className:"text-2xl font-bold mb-4",children:"Dynamic Loader Debug Test"}),/*#__PURE__*/_jsx("div",{className:"mb-4",children:/*#__PURE__*/_jsx("button",{onClick:startTest,className:"px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600",children:"Test Dynamic Loader"})}),/*#__PURE__*/_jsxs("div",{className:"mb-4 p-4 bg-gray-100 rounded",children:[/*#__PURE__*/_jsxs("h3",{className:"font-semibold mb-2",children:["Status: ",testCode?'Rendering':'Idle']}),renderError&&/*#__PURE__*/_jsxs("div",{className:"text-red-600 mb-2",children:[/*#__PURE__*/_jsx("strong",{children:"Error:"})," ",renderError]}),/*#__PURE__*/_jsxs("div",{className:"text-sm text-gray-600",children:[/*#__PURE__*/_jsx("strong",{children:"Using:"})," ComponentRenderer (dynamic rendering)"]})]}),/*#__PURE__*/_jsxs("div",{className:"border-2 border-dashed border-gray-300 p-4 rounded",children:[/*#__PURE__*/_jsx("h3",{className:"font-semibold mb-2",children:"Rendered Component:"}),testCode?/*#__PURE__*/_jsx("div",{className:"border p-4 rounded bg-white",children:/*#__PURE__*/_jsx(ComponentRenderer,{code:testCode,componentId:"debug-dynamic-loader-test",onError:handleError,className:"w-full"})}):/*#__PURE__*/_jsx("div",{className:"text-gray-500",children:"Click \"Test ComponentRenderer\" to start"})]}),/*#__PURE__*/_jsx("div",{className:"mt-4 text-xs text-gray-500",children:"Check the browser console for detailed debugging output from ComponentRenderer."})]});};export default DebugDynamicLoader;// Export to make this a module
export{};